<template>
  <div>
    <img src="@/assets/images/contatopic.png" alt="iso" class="cover-contato" />

    <div>
      <p class="contact-intro">{{ content.contato.texto_principal }}</p>
      <b-row style="align-items:center" class="phone-numbers">
        <b-col>
          <ul style="list-style: none; text-align: center; padding: 0">
            <li>
              <font-awesome-icon icon="briefcase" />
              <h6>
                {{ content.contato.comercial }}:
                <br />
                {{ content.contato.comercial_telefone_one }}
                <br />
                {{ content.contato.comercial_telefone_two }}
              </h6>
            </li>
            <li style="margin-top:20px">
              <font-awesome-icon icon="money-bill-alt" />
              <h6>
                {{ content.contato.financeiro }}:
                <br />
                {{ content.contato.financeiro_telefone_one }}
                <br />
                {{ content.contato.financeiro_telefone_two }}
              </h6>
            </li>
            <li style="margin-top:20px">
              <font-awesome-icon icon="tools" />
              <h6>
                {{ content.contato.tecnico }}:
                <br />
                {{ content.contato.tecnico_telefone_one }}
                <br />
                {{ content.contato.tecnico_telefone_two }}
              </h6>
            </li>
            <li style="margin-top:20px">
              <font-awesome-icon icon="shopping-cart" />
              <h6>
                {{ content.contato.compras }}:
                <br />
                {{ content.contato.compras_telefone_one }}
                <br />
                {{ content.contato.compras_telefone_two }}
              </h6>
            </li>
          </ul>
        </b-col>
        <b-col sm="12" md="8" style="height: 100%">
          <iframe
            class="map-wrapper"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            src="https://maps.google.com.br/maps?f=q&amp;source=s_q&amp;hl=pt-BR&amp;geocode=&amp;q=Sibrol+Brasil+-+Avenida+Itavuvu,+4501+-+Sorocaba&amp;aq=0&amp;oq=av+itavuvu&amp;sll=-14.239424,-53.186502&amp;sspn=43.220971,56.162109&amp;ie=UTF8&amp;hq=Sibrol&amp;hnear=Av.+Itavuvu,+4501+-+Jardim+S%C3%A3o+Camilo,+Sorocaba+-+S%C3%A3o+Paulo,+18075-042&amp;t=m&amp;ll=-23.447282,-47.479713&amp;spn=0.009449,0.013733&amp;z=16&amp;iwloc=A&amp;output=embed"
          ></iframe>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
// Json Content
import json from "../assets/content.json";
export default {
  name: "QualityVue",
  data() {
    return {
      content: json,
      publicPath: process.env.BASE_URL,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_standard.scss";
.cover-contato {
  width: 100%;
  max-height: 600px;
  object-fit: cover;
}

.phone-numbers {
  background-color: $primary-light-background;
  padding: 50px 0;

  margin: 0 auto 100px auto;
}

.icon-contact {
  font-size: 80px;
  color: $primary;
}

.map-wrapper {
  margin-top: 50px;
  width: 100%;
  height: 400px;
  @media (min-width: 768px) {
    margin-top: 0;
  }
}
</style>
